import dayjs from "dayjs";
import { KPIAdditionalFiltersType } from "../contexts/kpiContext";

export const createDigest = async (values: KPIAdditionalFiltersType) => {
    const str_values = [] as string[];

    if (values.startDate !== null)
        str_values.push(dayjs(values.startDate).toISOString())
    if (values.endDate !== null)
        str_values.push(dayjs(values.endDate).toISOString())
    if (values.businessEntity !== '')
        str_values.push(values.businessEntity)
    if (values.operatingAsset !== '')
        str_values.push(values.operatingAsset)
    if (values.siteName.length > 0)
        str_values.push(...values.siteName)
    return await generateUUIDFromArray(str_values);
}

function generateUUIDFromArray(values: string[]) {
    const joinedString = values.join('-');
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(joinedString))
        .then(hashBuffer => {
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            const hash = hashArray.map(b => ('00' + b.toString(16)).slice(-2)).join('');
            const uuid = `${hash.slice(0, 8)}-${hash.slice(8, 12)}-4${hash.slice(13, 16)}-${((parseInt(hash.slice(16, 20), 16) & 0x3fff) | 0x8000).toString(16)}-${hash.slice(20, 32)}`;
            return uuid;
        });
}